import React from 'react';
import AccountList from '../../components/AccountList/AccountList';


const CustomerAccounts = () => (
  <AccountList />
);

export default CustomerAccounts;
